window.showDeleteModal = () => {
  $('.js-deleteModal').modal({ backdrop: 'static' });
};
